<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
      <div class="card">
        <div class="card-body">
          <b-tabs nav-class="nav-tabs-custom" content-class="p-3 text-muted" lazy>
            <b-tab active>
              <template v-slot:title>
                <span class="d-inline-block d-sm-none">
                  <i class="fas fa-home"></i>
                </span>
                <span class="d-none d-sm-inline-block">Adicionar/Remover Tags</span>
              </template>
              <Tags />
            </b-tab>
            <b-tab>
              <template v-slot:title>
                <span class="d-inline-block d-sm-none">
                  <i class="fas fa-exchange-alt"></i>
                </span>
                <span class="d-none d-sm-inline-block">Mudar Status</span>
              </template>
              <ChangeStatus />
            </b-tab>
            <b-tab>
              <template v-slot:title>
                <span class="d-inline-block d-sm-none">
                  <i class="far fa-envelope"></i>
                </span>
                <span class="d-none d-sm-inline-block">Adicionar Anexos</span>
              </template>
              <WAStatusTemplates />
            </b-tab>
            <b-tab v-if="hasLogistics">
              <template v-slot:title>
                <span class="d-inline-block d-sm-none">
                  <i class="mdi mdi-airplane"></i>
                </span>
                <span class="d-none d-sm-inline-block">Bloqueios Aéreos</span>
              </template>
              <FlightBlockTask />
            </b-tab>
          </b-tabs>
        </div>
      </div>
  </Layout>
</template>
<script>
import Layout from '@/components/layout/vertical'
import PageHeader from '@/components/page-header'
import Tags from './tags/Index.vue'
import ChangeStatus from './change-status/Index.vue'
import FlightBlockTask from './flight-block/Index.vue'
import appConfig from '@/app.config'
import { mapState } from 'vuex'

export default {
  components: {
    Layout,
    PageHeader,
    Tags,
    ChangeStatus,
    FlightBlockTask
    // WATemplates,
    // WAStatusTemplates
  },
  name: 'setting-tasks',
  page: {
    title: 'Tarefas',
    meta: [{
      name: 'description',
      content: appConfig.description
    }]
  },
  data () {
    return {
      loading: true,
      submitted: false,
      configEvent: false,
      title: 'Tarefas',
      items: [{
        text: 'Configurações gerais',
        href: '/'
      },
      {
        text: 'Tarefas',
        active: true
      }
      ]
    }
  },
  async mounted () {
    if (!this.settingRSVP || Object.keys(this.settingRSVP).length === 0) {
      try {
        await this.$store.dispatch('settingRSVP/GetRSVP')
      } catch (err) {
        console.warn('Failed to load RSVP settings in tasks page:', err)
      }
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('settingRSVP', ['settingRSVP']),
    hasLogistics () {
      return this.settingRSVP && (
        this.settingRSVP.has_logistics === true ||
        this.settingRSVP.has_logistics === 1 ||
        this.settingRSVP.has_logistics === '1'
      )
    }
  },
  methods: {}
}
</script>
<style>
</style>
